package no.vareflow.app.domain

actual fun secureRandomBytes(count: Int): ByteArray {
    val array: dynamic = js("new Uint8Array(count)")
    js("globalThis.crypto.getRandomValues(array)")
    return ByteArray(count) { (array[it] as Int).toByte() }
}

internal actual fun derivePasswordKey(password: String, salt: ByteArray, iterations: Int): ByteArray =
    Crypto.pbkdf2Sha256(password.encodeToByteArray(), salt, iterations, 32)
